import { RISK } from "@/data/mockData";
import { cn } from "@/lib/utils";

export function RiskBadge({ level, label, className, showDot = true, ...props }) {
  const cfg = RISK[level] || RISK.SAFE;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-widest",
        className
      )}
      style={{
        color: cfg.hex,
        backgroundColor: cfg.tint,
        border: `1px solid ${cfg.border}`,
      }}
      {...props}
    >
      {showDot && (
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ backgroundColor: cfg.hex }}
        />
      )}
      {label || cfg.label}
    </span>
  );
}
